angular
    .module('tradersyard')
    .factory('group-settings-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();

                        tab = ['general', 'roles', 'skills', 'blacklist'].indexOf(hash) !== -1 ? hash : 'general';

                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('group-settings-ctrl', [
        '$scope',
        'graph-group-factory',
        'group-settings-filter',
        'graph-invite-factory',
        'graph-search-factory',
        '$flex',
        function ($scope, $factory, $filter, $invite, $search, $flex) {
            $scope.node = {};
            $scope.exhibition = undefined;
            $scope.filter = $filter;
            $scope.ui = {
                closeGroupForm: 0,
                mode: 'participant',
            };
            $scope.blacklists = {
                page: 0,
                data: [],
            };
            $scope.invites = {
                page: 0,
                data: [],
            };
            $scope.roles = {
                owner: {
                    page: 0,
                    data: [],
                },
                executive: {
                    page: 0,
                    data: [],
                },
                presenter: {
                    page: 0,
                    data: [],
                },
                trader: {
                    page: 0,
                    data: [],
                },
                pretrader: {
                    page: 0,
                    data: [],
                },
                listener: {
                    page: 0,
                    data: [],
                },
            };
            $scope.roleDictionary = {
                owner: ['owner', 'executive', 'presenter', 'trader', 'pretrader', 'listener'],
                executive: ['executive', 'presenter', 'trader', 'pretrader', 'listener'],
                presenter: ['presenter', 'trader', 'pretrader', 'listener'],
            };

            $scope.categories = [];
            $scope.participants = {
                page: 0,
                data: [],
            };
            $scope.current_role = undefined;

            $scope.onSubscriptionPlanChanges = function (plan) {
                $scope.node.subscription_plan.product_id = plan.product?.productId;
            };

            $scope.user = {
                search: function ($q) {
                    $scope.participants.data = [];
                    $search
                        .entry('user')
                        .search({ params: $q })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.participants.data = response.data.data;
                            }
                        });
                },
            };
            $scope.blacklist = {
                query: function (next) {
                    var params = {
                        page: ++$scope.blacklists.page,
                    };

                    $factory
                        .blacklists($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.blacklists.data = $scope.blacklists.data.concat(response.data.data);
                                if (next) next();
                            }
                        });
                },
                insert: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .insert(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.participants.data) {
                                    if ($scope.participants.data[i].id === user.id) {
                                        $scope.participants.data.splice(i, 1);
                                    }
                                }
                                $scope.blacklists.data = $scope.blacklists.data.concat(user);
                            }
                        });
                },
                delete: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .delete(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.blacklists.data) {
                                    if ($scope.blacklists.data[i].id === user.id) {
                                        $scope.blacklists.data.splice(i, 1);
                                    }
                                }
                            }
                        });
                },
            };
            $scope.invite = {
                search: function (q) {
                    $scope.invites.page = 0;
                    $scope.invites.data = [];
                    $scope.invite.query(q)();
                    $flex.$scroll.renew('roles');
                },
                query: function (q) {
                    return function (next) {
                        if (q === undefined || q === '') {
                            $scope.invite.find(next);
                            return;
                        }

                        ++$scope.invites.page;
                        var options = {
                            q: q,
                            page: $scope.invites.page,
                        };

                        $search
                            .place('group', $scope.node.id)
                            .search('invite', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    ++$scope.invites.page;
                    var options = {
                        page: $scope.invites.page,
                    };

                    $invite
                        .entry('group', $scope.node.id)
                        .query({ params: options })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };
            $scope.participant = {
                search: function (q) {
                    $scope.participants.page = 0;
                    $scope.participants.data = [];
                    $scope.participant.sQuery(q)();
                    $flex.$scroll.renew('roles');
                },
                sQuery: function (q) {
                    return function (next) {
                        if (q === '') {
                            $scope.participant.find(next);
                            return;
                        }

                        ++$scope.participants.page;
                        var options = {
                            q: q,
                            page: $scope.participants.page,
                            place: 'group.' + $scope.node.id,
                        };

                        $search
                            .place('group', $scope.node.id)
                            .search('participant', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.participants.data = $scope.participants.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                query: function (role) {
                    if ($scope.current_role !== role) {
                        $flex.$scroll.renew('roles');
                        $scope.current_role = role;
                    }

                    return function (next) {
                        ++$scope.roles[role].page;
                        var options = {
                            roles: role,
                            page: $scope.roles[role].page,
                        };

                        $factory
                            .participants($scope.node.id)
                            .query({ params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.roles[role].data = $scope.roles[role].data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    $flex.$scroll.renew('roles');
                    $scope.participant.query('owner')();
                    $scope.participant.query('executive')();
                    $scope.participant.query('presenter')();
                    $scope.participant.query('trader')();
                    $scope.participant.query('pretrader')();
                    $scope.participant.query('listener')();
                },
            };
            $scope.load = {
                categories: function () {
                    $factory.categories().then(function (response) {
                        if (response.data.state === 0) {
                            $scope.categories = response.data.data;
                        }
                    });
                },
            };

            $scope.changeMode = function (mode) {
                if (['participant', 'invite'].indexOf(mode) === -1) return;

                if (mode === $scope.ui.mode) return;

                $scope.search = '';

                switch (mode) {
                    case 'invite':
                        $scope.invites.page = 0;
                        $scope.invites.data = [];

                        $scope.invite.find();
                        break;
                    case 'participant':
                        $scope.participant.find();
                        break;
                }

                $scope.ui.mode = mode;
            };

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($scope.filter.tab());
                $scope.participants.data = [];
            };

            $scope.$error = {};
            $scope.buffer = {};
            $scope.duration = 0;
            $scope.queue = 0;
            $scope.queueConfirm = 0;
            $scope.order_info = undefined;

            $scope.submit = function () {
                if ($scope.queue === 0) {
                    $scope.queue = 1;

                    $scope.update($scope.node);
                }
            };

            $scope.closeGroup = function (node) {
                $factory.delete(node.id).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/groups');
                    }
                });
            };

            $scope.errors = {};

            $scope.confirmUpdateOrder = function () {
                if ($scope.queueConfirm === 0 && $scope.node.order_number != '') {
                    $scope.queueConfirm = 1;

                    $scope.update($scope.node);
                }
            };

            $scope.update = function (data) {
                $scope.errors = {};

                if ($scope.exhibition) {
                    data.exhibition_id = $scope.exhibition.id;
                    data.class_id = $scope.exhibition.class_id;
                }

                var $data = angular.copy(data);

                $data.category_id = $data.category.id;

                $factory.update($data.id, $data).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/group/' + $data.id);
                    } else {
                        $scope.queue = 0;
                        $scope.queueConfirm = 0;
                        $scope.errors = response.data.data;
                        window.scrollTo(0, 0);
                    }
                });
            };

            $scope.scheduledHandlingNewOrder = undefined;

            $scope.handleNewOrder = function (booth) {
                $scope.scheduledHandlingNewOrder = setInterval(function () {
                    $factory
                        .handleOrder(booth.id)
                        .then(function (response) {
                            if (response.data.state == 0) {
                                $scope.node.order_number = response.data.data.id || '';
                                $scope.order_info = response.data.data;

                                clearInterval($scope.scheduledHandlingNewOrder);
                                $scope.scheduledHandlingNewOrder = undefined;
                            }
                        })
                        .catch(function (response) {
                            $scope.errors = response.data.data;
                        });
                }, 3000);

                window.open(booth.url, '_blank');
            };

            $scope.relatedProduct = { url: '' };
            $scope.relatedProducts = [];

            $scope.addRelatedProduct = function () {
                var relatedProductUrl = $scope.relatedProduct.url;
                $scope.relatedProductError = undefined;
                $scope.relatedProduct.url = '';

                $factory.addRelatedProduct($scope.node.id, relatedProductUrl).then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.relatedProducts || [])
                                .map(function (relatedProduct) {
                                    return relatedProduct.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.relatedProducts = ($scope.relatedProducts || []).concat([response.data.data]);
                            }
                        } else {
                            $scope.relatedProductError = response.data.data.url;
                            $scope.relatedProduct.url = relatedProductUrl;
                        }
                    },
                    function (error) {
                        $scope.relatedProductError = 'An error occurred';
                        $scope.relatedProduct.url = relatedProductUrl;
                    }
                );
            };

            $scope.removeRelatedProduct = function (linkId) {
                $factory.removeRelatedProduct($scope.node.id, linkId).then(function (response) {
                    var index = ($scope.relatedProducts || [])
                        .map(function (relatedProduct) {
                            return relatedProduct.id;
                        })
                        .indexOf(linkId);

                    if (index >= 0) {
                        $scope.relatedProducts.splice(index, 1);
                    }
                });
            };

            $scope.$on('touch:general', function () {
                $scope.load.categories();

                $factory.queryRelatedProducts($scope.node.id).then(function (response) {
                    $scope.relatedProducts = response.data.data;
                });
            });

            $scope.$on('touch:roles', function () {
                $scope.participant.find();
            });

            $scope.$on('touch:blacklist', function () {
                $scope.blacklist.query();
            });

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
